var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Fragment, useEffect } from "react";
import { Box, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, ModalFooter, Flex, ModalCloseButton, Text, Button, Divider, } from "@reverb-ui/react";
import { useForm, useFieldArray } from "react-hook-form";
import { PlusSquare, Trash } from "@reverb-ui/icons-react";
import { useLocationCountries } from "@/shared/hooks/use-location-countries";
import { ModalCompanyOwnerAddressForm } from "./modal-company-owner-address-form";
import { useAddressTypes } from "@/shared/hooks/use-address-types";
import { useTranslation } from "react-i18next";
function formatData(addresses) {
    return {
        addresses: addresses.map(function (adr) { return ({
            addressId: adr.id,
            zipCode: adr.zipCode,
            addressType: {
                value: adr.type.id.toString(),
                label: adr.type.description,
            },
            country: {
                value: adr.country.id.toString(),
                label: adr.country.description,
            },
            state: { value: adr.state.id.toString(), label: adr.state.description },
            city: { value: adr.city.id.toString(), label: adr.city.description },
            neighborhood: adr.neighborhood,
            street: adr.street,
            number: adr.number,
            complement: adr.complement,
        }); }),
    };
}
function formatFormDataObjectToAddressInput(address) {
    return {
        addressId: address.addressId,
        zipCode: address.zipCode,
        typeId: +address.addressType.value,
        countryId: +address.country.value,
        stateId: +address.state.value,
        cityId: +address.city.value,
        neighborhood: address.neighborhood,
        street: address.street,
        number: address.number,
        complement: address.complement,
        reference: undefined,
    };
}
export var ModalCompanyOwnerAddress = function (_a) {
    var isOpen = _a.isOpen, addresses = _a.addresses, onClose = _a.onClose, onSubmit = _a.onSubmit;
    var t = useTranslation("my-account").t;
    var innerModalOnClose = function () {
        reset(formatData(addresses));
        onClose();
    };
    var onSubmitForm = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var addressesToDelete, addressesToUpdate, addressesToCreate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    addressesToDelete = addresses === null || addresses === void 0 ? void 0 : addresses.filter(function (address) { return !data.addresses.find(function (adr) { return adr.addressId === address.id; }); });
                    addressesToUpdate = data.addresses.filter(function (address) {
                        return address.addressId &&
                            addresses.find(function (adr) { return adr.id === address.addressId; });
                    });
                    addressesToCreate = data.addresses.filter(function (address) { return !(addresses === null || addresses === void 0 ? void 0 : addresses.find(function (adr) { return adr.id === address.addressId; })); });
                    return [4 /*yield*/, onSubmit(addressesToDelete.map(function (adr) { return adr.id; }), addressesToUpdate.map(formatFormDataObjectToAddressInput), addressesToCreate.map(formatFormDataObjectToAddressInput))];
                case 1:
                    _a.sent();
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    var _b = useForm({
        defaultValues: formatData(addresses),
    }), handleSubmit = _b.handleSubmit, register = _b.register, reset = _b.reset, setValue = _b.setValue, control = _b.control, _c = _b.formState, errors = _c.errors, isSubmitting = _c.isSubmitting, isSubmitSuccessful = _c.isSubmitSuccessful;
    var _d = useFieldArray({
        control: control,
        name: "addresses",
        keyName: "addressId",
    }), fields = _d.fields, append = _d.append, remove = _d.remove;
    var _e = useLocationCountries(true), countries = _e.countries, countriesIsLoading = _e.isLoading;
    var addressTypes = useAddressTypes(true).addressTypes;
    var showRemoveButton = fields.length > 1;
    useEffect(function () {
        if (isSubmitSuccessful)
            reset(formatData(addresses));
    }, [isSubmitSuccessful]);
    return (React.createElement(Box, { w: "full" },
        React.createElement(Modal, { isOpen: isOpen, onClose: innerModalOnClose, size: "3xl" },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalHeader, null,
                    t("company-tab.modal-edit-address.edit-companys-address"),
                    React.createElement(ModalCloseButton, null)),
                React.createElement("form", { onSubmit: handleSubmit(onSubmitForm) },
                    React.createElement(ModalBody, { overflow: "auto" },
                        React.createElement(Flex, { flexDirection: "column", justifyContent: "center", w: "100%" },
                            React.createElement(Text, { fontSize: "lg", mb: "24px" }, t("company-tab.modal-edit-address.address")),
                            fields.map(function (address, index) {
                                return (React.createElement(Fragment, { key: address.addressId },
                                    React.createElement(ModalCompanyOwnerAddressForm, { register: register, address: address, index: index, countries: countries, countriesIsLoading: countriesIsLoading, addressTypes: addressTypes, control: control, setValue: setValue, formErrors: errors, isSubmitting: isSubmitting }),
                                    showRemoveButton && (React.createElement(Flex, { flexDirection: "row", justifyContent: "flex-end", py: "32px" },
                                        React.createElement(Flex, { onClick: function () { return remove(index); }, alignItems: "center", cursor: "pointer", gap: "10px" },
                                            React.createElement(Trash, { variant: "outline", color: "blue.500" }),
                                            React.createElement(Text, { color: "blue.500" }, t("company-tab.modal-edit-address.remove-address"))))),
                                    React.createElement(Divider, null)));
                            }),
                            React.createElement(Flex, { flexDirection: "row", justifyContent: "flex-start", py: "32px" },
                                React.createElement(Flex, { onClick: function () { return append({}); }, alignItems: "center", cursor: "pointer", gap: "10px" },
                                    React.createElement(PlusSquare, { variant: "solid", color: "blue.500" }),
                                    React.createElement(Text, { color: "blue.500" }, t("company-tab.modal-edit-address.add-address")))))),
                    React.createElement(ModalFooter, null,
                        React.createElement(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-end", p: "0", gap: "24px" },
                            React.createElement(Button, { variant: "outline", onClick: innerModalOnClose, isLoading: isSubmitting }, t("company-tab.modal-edit-address.cancel")),
                            React.createElement(Button, { colorScheme: "blue", type: "submit", isLoading: isSubmitting }, t("company-tab.modal-edit-address.save")))))))));
};
